export const BASE_COSTING_TAB_ID = 'BASE_COSTING';

/**
 * Reasons shown inside the "Create new costing option" modal.
 * Sent to the API as the `reasons` payload, e.g. ["FABRIC", "WASH"].
 */
export const NEW_COSTING_OPTION_REASONS = [
	{ value: 'NEW_FACTORY', label: 'New factory' },
	{ value: 'FABRIC', label: 'Fabric' },
	{ value: 'PRINT', label: 'Print' },
	{ value: 'WASH', label: 'Wash' },
	{ value: 'EMBROIDERY', label: 'Embroidery' },
	{ value: 'OTHERS', label: 'Others' }
];

/**
 * Quote id of the costing details page, e.g. /costing/399352
 */
export const getQuoteIdFromUrl = (pathname = window?.location?.pathname || '') => {
	const matchedQuoteId = pathname.match(/\/costing\/(\d+)/);
	return matchedQuoteId ? matchedQuoteId[1] : null;
};

/**
 * Empty (UI only) values of an option, the costing data of an option
 * will be loaded through its own APIs later.
 */
const emptyCostingOptionData = {
	selectedSupplier: {},
	documents: [],
	costList: [],
	remarks: '',
	moq: '',
	totalCost: '',
	createdBy: '',
	lastModifiedAt: null,
	costingHistory: []
};

/**
 * Maps `[{ name: 'OP-1', initialCostingId: 154264 }]` to the option
 * objects used by the tabs, keeping already loaded data of an option.
 */
export const mapCostingOptions = (optionList = [], previousOptions = []) =>
	optionList.map((option) => {
		const optionId = String(option?.initialCostingId ?? option?.id ?? option?.name);
		const previousOption = previousOptions.find((item) => item.id === optionId);
		return {
			...emptyCostingOptionData,
			...previousOption,
			id: optionId,
			initialCostingId: option?.initialCostingId ?? null,
			label: option?.name || '',
			isSelectedTab: !!option?.isSelectedTab
		};
	});
